module.exports = __webpack_public_path__ + "img/dish.61fd5f5c.png";